import { ConnectAccountsCta } from "@components/billing/PlanManagement/ConnectAccountsCta";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { FC } from "react";
import {
    INVOICE_CONNECT_CTA_SUBTITLE,
    INVOICE_CREATE_CTA_TITLE,
    InvoiceConnectButtons,
} from "./invoiceConnectCta";

export type InvoiceTableViewKind = "invoices" | "lineItems" | "customers";

type InvoiceTableEmptyViewVariant =
    | "loading"
    | "filtered"
    | "connect"
    | "no-data"
    | "none";

const FILTER_EMPTY_HEADERS: Record<InvoiceTableViewKind, string> = {
    invoices: "The filters don't match any invoices.",
    lineItems: "The filters don't match any line items.",
    customers: "The filters don't match any customers.",
};

interface InvoiceTableEmptyViewProps {
    variant: Exclude<InvoiceTableEmptyViewVariant, "loading" | "none">;
    viewKind: InvoiceTableViewKind;
    onClearFilters: () => void;
}

export const InvoiceTableEmptyView: FC<InvoiceTableEmptyViewProps> = ({
    variant,
    viewKind,
    onClearFilters,
}) => {
    const shouldShowCta = variant === "connect" || variant === "no-data";

    if (shouldShowCta) {
        return (
            <ConnectAccountsCta
                title={INVOICE_CREATE_CTA_TITLE}
                subtitle={INVOICE_CONNECT_CTA_SUBTITLE}
            >
                <InvoiceConnectButtons />
            </ConnectAccountsCta>
        );
    }

    return (
        <EmptyState
            header={FILTER_EMPTY_HEADERS[viewKind]}
            action={onClearFilters}
        />
    );
};
